import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { incidentOperations } from '../../redux/incident';
import debounce from 'lodash/debounce';
import { loadModules } from 'esri-loader';
import CertifyDialog from './CertifyDialog';
import IncidentDetailsHeader from './IncidentDetailsHeader';
import DetailsDashboardPanel from './DetailsDashboardPanel';
import DetailsIncidentPanel from './DetailsIncidentPanel';
import FireCausePanel from './customPanels/FireCausePanel';
import MultiAgencyResponsePanel from './customPanels/MultiAgencyResponsePanel';
import MergeInfoPanel from './customPanels/MergeInfoPanel';
import EditGeometryToolbar from './editGeometry/EditGeometryToolbar';
import AlertPanel from '../AlertPanel';
import Dialog from 'material-ui/Dialog';
import Button from '@mui/material/Button';
import Snackbar from '@material-ui/core/Snackbar';
import {
  getRequiredFields, getValidationInfo, isPerimeterTriangleOrMissing, isPerimeterMultipart, getAcresFromIncident, getMissingFieldsCount,
  isIncidentComplete, isIncidentCertified, is209, isIncidentFederal, findDuplicateAttributes,
  isPerimeterTriangle, getTriangleSideLengthForAcreage, distanceToVertex
} from '../../utils/incidentHelper';

import { clearModifiedPerimeter, refreshOriginLayer, setPerimeterSymbology, isOriginWithinPerimeter, setModifiedPerimeter, setPerimeterGraphic, clearPerimeterGraphics, clearMergedPerimeterGraphics} from '../esri/mapHub';

import originFields from '../../defaults/PointOfOriginFields.json';
import perimeterFields from '../../defaults/UncertifiedPerimeterFields.json';
import enums from '../../defaults/Enums.json';
import symbols from '../../defaults/Symbols.json';

import './IncidentDetailsContainer.css';
import theme from '../../muiTheme';


const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
}

class IncidentDetailsContainer extends Component {

  constructor(props) {

    super(props);
    this.geometryToolbarChild = React.createRef();

    const isFederal = isIncidentFederal(this.props.incident);
    const originValidation = getValidationInfo(enums.validationType.origin, this.props.incident.attributes, this.props.appConfig.fieldInfos);
    const isCertified = isIncidentCertified(this.props.incident);
    const isIncident209 = is209(this.props.incident);

    let perimeterValid = true;
    let perimeterTriangle = isPerimeterTriangleOrMissing(this.props.perimeter);
    let isMultipartPerimeter = isPerimeterMultipart(this.props.perimeter);
    let incidentAcreage = getAcresFromIncident(this.props.incident);

    const emptyValidation =
    {
      isValid: true,
      invalidFields: [],
      errors: {}
    };

    const perimeterValidationType = (isFederal && (incidentAcreage >= 10)) ? enums.validationType.perimeter : enums.validationType.bypassValidation;
    const perimeterValidation = (this.props.perimeter && this.props.perimeter.attributes) ? getValidationInfo(perimeterValidationType, this.props.perimeter.attributes, this.props.appConfig.perimeterFieldInfos) : emptyValidation;

    this.state = {
      mode: "read", //"edit"
      editableIncident: null,
      editablePerimeter: null,
      updateStatus: "",
      errorMessage: "",
      editWasCancelled: false,
      clientDerivedPolygonAcres: null,
      editableAcres: {},
      editableAcresDirty: false,
      isRetrieving: false,
      isComplete: isIncidentComplete(this.props.incident),
      isMultipartPerimeter: isMultipartPerimeter,
      missingFieldsCount: getMissingFieldsCount(this.props.incident),
      originValidation: originValidation,
      perimeterValidation: perimeterValidation,
      isPerimeterValid: perimeterValid,
      isOriginValid: originValidation.isValid,
      incidentAcres: incidentAcreage,
      originWithinPerimeter: true,
      isPerimeterTriangle: perimeterTriangle,
      showTriangleRegenerationDialog: false,
      isCertified: isCertified,
      is209: isIncident209,
      isSaveActive: false,
      isFederal: isFederal,
      perimeterValidationType: perimeterValidationType,
      manualLat: null,
      manualLong: null,
      isRecalculatingAcres: false,
      fireCodeRequested: (this.props.incident.attributes[originFields.isFireCodeRequested] === 1),
      warnForMissingRelationships: this.props.missingConflictRelationships,
      showCertifyAgreement: false,
      requestFireCodeWarnIssued: false,
      showUSFSFireCodeDialog: false,
      collapseCompletePanels: false,
      expandAllPanels: false,
      perimeterWasAdded: false,
      perimeterWasEdited: false,
      perimeterWasRecalced: false,
      startView: new Date(),
      startEdit: null
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.incident && prevProps.incident && this.props.incident.attributes && prevProps.incident.attributes) 
    {
      if (this.props.incident.attributes[originFields.forId] !== prevProps.incident.attributes[originFields.forId]) {
        this.setState({
          isComplete: isIncidentComplete(this.props.incident),
          isCertified: isIncidentCertified(this.props.incident),
          missingFieldsCount: getMissingFieldsCount(this.props.incident),
          startView: new Date(),
          startEdit: null,
          showTriangleRegenerationDialog: false
        });
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.perimeter && Object.entries(nextProps.perimeter).length > 0) {
      if (JSON.stringify({ ...nextProps.perimeter }) !== JSON.stringify({ ...this.props.perimeter })) {
        const nextPerimeterValidation = getValidationInfo(this.state.perimeterValidationType, nextProps.perimeter.attributes, this.props.appConfig.perimeterFieldInfos);

        this.setState({
          perimeterValidation: nextPerimeterValidation.errors,
          isPerimeterValid: nextPerimeterValidation.isValid,
          isPerimeterTriangle: isPerimeterTriangleOrMissing(nextProps.perimeter),
          incidentAcres: getAcresFromIncident(nextProps.incident),
          isMultipartPerimeter: isPerimeterMultipart(nextProps.perimeter)
        });

      }
    }

    if (nextProps.perimeter && nextProps.incident) {
      if (JSON.stringify({ ...nextProps.perimeter }) !== JSON.stringify({ ...this.props.perimeter }) || JSON.stringify({ ...nextProps.incident.geometry }) !== JSON.stringify({ ...this.props.incident.geometry })) {
        isOriginWithinPerimeter(nextProps.perimeter, nextProps.incident.attributes.x, nextProps.incident.attributes.y).then(
          result => {
            this.setState({
              originWithinPerimeter: result
            });
          });
      }
    }
  }

  closeDetailsClicked = () => {
    this.setState({
      mode: "read",
      editableIncident: null,
      editablePerimeter: null,
      updateStatus: "",
      errorMessage: "",
      editableAcres: null,
      originValidation: null,
      perimeterValidation: null,
      isSaveActive: false,
      originWithinPerimeter: true,
      perimeterWasRecalced: false,
      showTriangleRegenerationDialog: false,
    });

    const closeDate = new Date();

    if (this.state.startView !== null) 
    {
        var timeDiff = closeDate - this.state.startView; 
        timeDiff /= 1000;

        // get seconds 
        var seconds = Math.round(timeDiff);
        window.api.logTime(this.props.incident.attributes[originFields.fireOccurenceRecordID], seconds, 0).then(response => {

        });
    }

    this.props.onCloseDetailsClicked();
  }
  editClicked = () => {
    this.setState({
      mode: "edit",
      editableIncident: { attributes: (this.props.incident) ? this.props.incident.attributes : null },
      //editablePerimeter: { attributes: (this.props.perimeter) ? this.props.perimeter.attributes : null },
      editablePerimeter: Object.assign({}, this.props.perimeter),
      editableAcres: Object.assign({}, this.props.incident.perimeterAcreage),
      updateStatus: "",
      errorMessage: "",
      isSaveActive: false,
      editWasCancelled: false,
      manualLat: null,
      manualLong: null,
      perimeterWasRecalced: false,
      startEdit: new Date()
    });
  }

  cancelEditClicked = () => {
    this.setState({
      mode: "read",
      editableIncident: null,
      editWasCancelled: true,
      editableAcres: null,
      editableAcresDirty: false,
      editablePerimeter: this.props.perimeter,
      updateStatus: "",
      errorMessage: "",
      isSaveActive: false,
      isRecalculatingAcres: false,
      perimeterWasRecalced: false
    });

    this.geometryToolbarChild.current.editWasCancelled();
  }

  handleErrorDialogClose = () => {
    this.setState({ errorMessage: "" });
  };

  handleRelationshipsDialogClose = () => {
    this.setState({ warnForMissingRelationships: false });
  };

  handleFSFireCodeYes = () => {
    this.setState({ showUSFSFireCodeDialog: false });
    this.requestFireCode();
  };

  setPanelCollapseFlag = () => {
    if (this.state.collapseCompletePanels) {
      this.setState({
        collapseCompletePanels: false,
        expandAllPanels: true
      });
    }
    else {
      this.setState({
        collapseCompletePanels: true,
        expandAllPanels: false
      });
    }
  }

  resetPanelCollapseFlag = () => {
    this.setState({
      collapseCompletePanels: false,
      expandAllPanels: false
    });
  }

  handleFSFireCodeNo = () => {
    this.setState(
      {
        showUSFSFireCodeDialog: false,
        requestFireCodeWarnIssued: false
      }
    );
  };

  handleTriangleRegenerationYes = () => {
    this.generateNewTriangle();
    
    this.setState(
      {
        showTriangleRegenerationDialog: false
      }
    );
  };


  handleTriangleRegenerationNo = () => {
    this.setState(
      {
        showTriangleRegenerationDialog: false
      }
    );
  };


  fireReportingStatusUpdated = (incident) => {
    const updatedIncident = {
      //attributes: results[0].attributes,
      attributes: Object.assign({}, incident.attributes,
        {
          "_pointGeometryLatitude": incident.geometry.y,
          "_pointGeometryLongitude": incident.geometry.x
        }
      ),
      geometry: incident.geometry
    }

    this.props.refetchIncident(updatedIncident.attributes[originFields.forId]);
    //    this.props.setIncident(updatedIncident);
  }

  //TODO: Rewrite this entire thing
  saveChangesClicked = () => {
    this.setState({
      updateStatus: "Saving Changes..."
    });

    const closeDate = new Date();

    if (this.state.startEdit !== null) 
    {
        var timeDiff = closeDate - this.state.startEdit; 
        timeDiff /= 1000;

        // get seconds 
        var seconds = Math.round(timeDiff);
        window.api.logTime(this.props.incident.attributes[originFields.fireOccurenceRecordID], seconds, 1).then(response => {

        });
    }

    const perimeterIsNew = ((this.state.editablePerimeter && (this.state.editablePerimeter.attributes || this.state.editablePerimeter.geometry)) &&
      (this.props.perimeter === null || this.props.perimeter === undefined));

    if (perimeterIsNew) 
    {
      window.api.addNewPerimeter(this.state.editablePerimeter, this.state.editableIncident.attributes).then(
        result => {
          setPerimeterGraphic(result.Feature);
          clearModifiedPerimeter();

          this.setState({
            mode: "read",
            editablePerimeter: result.Feature,
            isSaveActive: false
          });
        });
    }

      //If perimeter exists save changes
      if ( (!perimeterIsNew) && this.state.editablePerimeter && (this.state.editablePerimeter.attributes || this.state.editablePerimeter.geometry)) 
      {
        const attributesChanged = (JSON.stringify(this.state.editablePerimeter.attributes) !== JSON.stringify(this.props.perimeter.attributes));

        const attrs = (this.state.editablePerimeter.attributes) ? this.state.editablePerimeter.attributes : this.props.perimeter.attributes;
        let feature = {
          attributes: attrs
        };

        let geom = (this.state.editablePerimeter.geometry);
        const geometryChanged = (this.state.editablePerimeter && this.state.editablePerimeter.geometry && JSON.stringify(this.state.editablePerimeter.geometry) !== JSON.stringify(this.props.perimeter.geometry));

        if (geometryChanged) {
          feature.geometry = geom;

          if (!feature.geometry.type) {
            feature.geometry.type = 'polygon';
          }
        }
        else {
          feature.geometry = this.props.perimeter.geometry;
        }

        if (attributesChanged || geometryChanged) {
         const perimeterSource = this.props.incident.perimeter.Feature.PerimeterSource;
          window.api.updatePerimeter(feature, this.props.incident, geometryChanged, perimeterSource).then(
            result => {

              setPerimeterGraphic(result.Feature);
              clearModifiedPerimeter();

              this.setState({
                mode: "read",
                editablePerimeter: null,
                isSaveActive: false
              });

            },
            error => {
              console.warn(error);
              console.warn('View Fire Perimeter failed', error);
              this.showError((
                <Fragment>
                  <p>There was a problem viewing the fire perimeter</p>
                </Fragment>
              ));
            }
          )
        }
      }

    const incidentAttributesChanged = (JSON.stringify(this.state.editableIncident.attributes) !== JSON.stringify(this.props.incident.attributes));
    const acreageChanged = this.state.editableAcresDirty;
    const clientRecalced = this.state.perimeterWasRecalced;

    if (this.state.editableIncident.geometry || incidentAttributesChanged || acreageChanged) {
      let updatedIncident = Object.assign({}, this.state.editableIncident);
      const updatedAcreage = (acreageChanged) ? Object.assign({}, this.state.editableAcres) : null;

      const unchangedFields = findDuplicateAttributes(this.props.incident, updatedIncident);
      window.api.saveOccurenceRecord(updatedIncident, updatedAcreage, unchangedFields, clientRecalced)
        .then(
          result => {
            if (result) {

              const originValidation = getValidationInfo(enums.validationType.origin, result.attributes, this.props.appConfig.fieldInfos);

              this.setState({
                mode: "read",
                updateStatus: "Incident Saved Successfully!",
                editableIncident: null,
                isComplete: isIncidentComplete(result),
                missingFieldsCount: getMissingFieldsCount(result),
                originValidation: originValidation,
                isOriginValid: originValidation.isValid,
                isFederal: isIncidentFederal(result)
              });

              this.props.refetchIncident();
            }
          });
    }
  }

  setUpdated = (fields, values) => {
    let updatedProp = {};

    for (var i = 0; i < fields.length; i++) {
      updatedProp[fields[i]] = values[i];
    }

    if (this.state.editableIncident && this.state.editableIncident.attributes) {
      const updatedAttributes = {
        attributes: Object.assign({}, this.state.editableIncident.attributes, updatedProp)
      };

      const updatedIncident = Object.assign({}, this.state.editableIncident, updatedAttributes);

      const originValidation = getValidationInfo(enums.validationType.origin, updatedIncident.attributes, this.props.appConfig.fieldInfos);
      this.setState({
        editableIncident: updatedIncident,
        originValidation: originValidation,
        isOriginValid: originValidation.isValid,
        isSaveActive: true
      });
    }
  }

  onAcreageLandownerCategoryUpdated = (index, value) => {
    let updatedProp = Object.assign({}, this.state.editableAcres);

    updatedProp.AcreageRecords[index] = Object.assign({}, this.state.editableAcres.AcreageRecords[index]);
    updatedProp.AcreageRecords[index].LandownerCategoryID = value;

    this.setState({
      editableAcres: updatedProp,
      editableAcresDirty: true,
      isSaveActive: true
    });
  }

  onAddNewAcreageRow = () => {
    let updatedProp = Object.assign({}, this.state.editableAcres);

    updatedProp.AcreageRecords.push({
      LandownerCategoryID: 18,
      UserProvidedAcreage: 0,
      CanEditLandowner: true,
      AcreageRecordID: -1
    })

    this.setState({
      editableAcres: updatedProp,
      editableAcresDirty: true,
      isSaveActive: true
    });

  }

  onAcreageRecalculate = () => {
      window.api.deriveAcresByJurisdiction(this.props.incident.perimeter.Feature.geometry).then(derivedJurisAcresResult => {
        this.reconcileEditableAcreages(derivedJurisAcresResult);
        this.setState({
          clientDerivedPolygonAcres: derivedJurisAcresResult,
          perimeterWasRecalced: true,
          isSaveActive: true,
          editableAcresDirty: true,
        });
      });
  }

  onAcreagePropRemoved = (index) => {
    let updatedProp = Object.assign({}, this.state.editableAcres);
    updatedProp.AcreageRecords = [];

    for (var i = 0; i < this.state.editableAcres.AcreageRecords.length; i++) {
      if (i !== index) {
        updatedProp.AcreageRecords.push(Object.assign({}, this.state.editableAcres.AcreageRecords[i]));
      }
    }

    this.setState({
      editableAcres: updatedProp,
      editableAcresDirty: true,
      isSaveActive: true
    });
  }

  onAcreagePropUpdated = (num, index) => {

    let updatedProp = Object.assign({}, this.state.editableAcres);
    updatedProp.AcreageRecords[index].LandownerCategoryID = this.state.editableAcres.AcreageRecords[index].LandownerCategoryID;
    updatedProp.AcreageRecords[index].IsUserOverriden = true;
    updatedProp.AcreageRecords[index].UserProvidedAcreage = (isNaN(num)) ? null : num;
   
    this.setState({
      editableAcres: updatedProp,
      editableAcresDirty: true,
      isSaveActive: true
    });

  }

  onBeneficialAcreagePropUpdated = (num, index) => {

    debugger;
    let updatedProp = Object.assign({}, this.state.editableAcres);
    updatedProp.AcreageRecords[index].LandownerCategoryID = this.state.editableAcres.AcreageRecords[index].LandownerCategoryID;
    updatedProp.AcreageRecords[index].IsUserOverriden = true;
    updatedProp.AcreageRecords[index].BeneficialAcres = (isNaN(num)) ? null : num;
   
    this.setState({
      editableAcres: updatedProp,
      editableAcresDirty: true,
      isSaveActive: true
    });

  }

  agencyPropUpdated = (fieldName, agencyVal) => {
    let valueChanged = false;
    let updatedProp = {};

    if (fieldName === originFields.pooProtectingUnit && agencyVal.toUpperCase() !== this.state.editableIncident.attributes[originFields.pooProtectingAgency]) {
      updatedProp[originFields.pooProtectingAgency] = agencyVal.toUpperCase();
      valueChanged = true;
    }

    if (fieldName === originFields.pooJurisdictionalUnit && agencyVal.toUpperCase() !== this.state.editableIncident.attributes[originFields.incidentJurisdictionalAgency]) {
      updatedProp[originFields.incidentJurisdictionalAgency] = agencyVal.toUpperCase();
      valueChanged = true;
    }

    if (this.state.editableIncident && this.state.editableIncident.attributes && valueChanged) {
      const updatedAttributes = { attributes: Object.assign({}, this.state.editableIncident.attributes, updatedProp) };

      const updatedIncident = Object.assign({}, this.state.editableIncident, updatedAttributes);
      const originValidation = getValidationInfo(enums.validationType.origin, updatedIncident.attributes, this.props.appConfig.fieldInfos);

      this.setState({
        editableIncident: updatedIncident,
        originValidation: originValidation,
        isOriginValid: originValidation.isValid,
        isSaveActive: true
      });
    }
  }

  removeInitialResponseAgency = (removeAgency) => {
    let updatedProp = {};
    updatedProp["InitialResponseAgencies"] = [];
    if (this.state.editableIncident.attributes.InitialResponseAgencies !== null && this.state.editableIncident.attributes.InitialResponseAgencies.length > 0) {
      for (var i = 0; i < this.state.editableIncident.attributes.InitialResponseAgencies.length; i++) {
        if (this.state.editableIncident.attributes.InitialResponseAgencies[i] !== removeAgency) {
          updatedProp["InitialResponseAgencies"].push(this.state.editableIncident.attributes.InitialResponseAgencies[i]);
        }
      }
    }

    if (this.state.editableIncident && this.state.editableIncident.attributes) {
      const updatedAttributes = {
        attributes: Object.assign({}, this.state.editableIncident.attributes, updatedProp)
      };

      const updatedIncident = Object.assign({}, this.state.editableIncident, updatedAttributes);
      const originValidation = getValidationInfo(enums.validationType.origin, updatedIncident.attributes, this.props.appConfig.fieldInfos);

      this.setState({
        editableIncident: updatedIncident,
        originValidation: originValidation,
        isOriginValid: originValidation.isValid,
        isSaveActive: true
      });
    }
  }

  addInitialResponseAgency = (addAgency) => {
    let updatedProp = {};
    updatedProp["InitialResponseAgencies"] = [];
    if (this.state.editableIncident.attributes.InitialResponseAgencies !== null && this.state.editableIncident.attributes.InitialResponseAgencies.length > 0) {
      for (var i = 0; i < this.state.editableIncident.attributes.InitialResponseAgencies.length; i++) {
        updatedProp["InitialResponseAgencies"].push(this.state.editableIncident.attributes.InitialResponseAgencies[i]);
      }
    }
    updatedProp["InitialResponseAgencies"].push(addAgency);

    if (this.state.editableIncident && this.state.editableIncident.attributes) {
      const updatedAttributes = {
        attributes: Object.assign({}, this.state.editableIncident.attributes, updatedProp)
      };

      const updatedIncident = Object.assign({}, this.state.editableIncident, updatedAttributes);
      const originValidation = getValidationInfo(enums.validationType.origin, updatedIncident.attributes, this.props.appConfig.fieldInfos);

      this.setState({
        editableIncident: updatedIncident,
        originValidation: originValidation,
        isOriginValid: originValidation.isValid,
        isSaveActive: true
      });
    }
  }

  attemptSetAgency = (unitId, fieldToSet) => {
    window.api.getUnitId(unitId).then(unitIdResponse => {
      const unitIdIsValid = (unitIdResponse && unitIdResponse.units && unitIdResponse.units.length > 0);
      if (unitIdIsValid)
      {
        this.propUpdated(fieldToSet,unitIdResponse.units[0].AGENCY);
      }
   });
  }

  propUpdated = (fieldName, newVal) => {

    let updatedProp = {};
    updatedProp[fieldName] = newVal;

    if (fieldName === originFields.incidentTypeCategory) 
    {
        if (newVal === "FA") 
        {
          if (this.props.selectedIncident.perimeter && !this.state.isPerimeterTriangle) 
          {
            this.setState({
              updateStatus: "Incident has a valid perimeter, cannot change type to False Alarm",
              isSaveActive: false
            });
            return;
          }

          updatedProp[originFields.incidentSize] = null;      //null out incident size if we're an FA now
          updatedProp[originFields.calculatedAcres] = null;   //null out calculated size if we're an FA now
          
          let updatedAcresProp = {};
          
          updatedAcresProp.AcreageRecords = [];
          this.setState({
            editableAcres: updatedAcresProp,
            perimeterWasRecalced: true,
            updateStatus: "Ownership acres have been reset for False Alarm",
            editableAcresDirty: true,
            isSaveActive: true
          });
        }
    }

    if (fieldName === originFields.incidentSize) 
      {
      updatedProp[fieldName] = Math.max(Math.round(newVal * 100) / 100, newVal).toFixed(2);
      if (this.state.editablePerimeter && this.state.editablePerimeter.geometry && isPerimeterTriangle(this.state.editablePerimeter)) {
        this.generateNewTriangle(updatedProp[fieldName]);
      }
    }

    if (fieldName === originFields.pooJurisdictionalUnit || fieldName === originFields.pooProtectingUnit) 
    {
      updatedProp[fieldName] = newVal.toUpperCase();
      const agencyToSet = (fieldName === originFields.pooJurisdictionalUnit) ? originFields.incidentJurisdictionalAgency : originFields.pooProtectingAgency;
      this.attemptSetAgency(newVal.toUpperCase(), agencyToSet);
    }

    if (fieldName === originFields.fireCauseId) {
      //  updatedProp[originFields.fireCauseGeneralId] = this.getDefaultCauseGeneral(newVal);
      updatedProp[originFields.fireCauseGeneralId] = null;
      updatedProp[originFields.fireCauseSpecificId] = null;
      updatedProp[originFields.fireCauseActivityGroupID] = null;
      updatedProp[originFields.fireCauseAgeCategoryID] = null;
      updatedProp[originFields.fireCauseSpecificDetailID] = null;
      updatedProp[originFields.isCauseProhibited] = null;
    }

    if (fieldName === originFields.fireCauseGeneralId) {
      updatedProp[originFields.fireCauseSpecificId] = null;
      updatedProp[originFields.fireCauseAgeCategoryID] = null;
      updatedProp[originFields.fireCauseActivityGroupID] = null;
      updatedProp[originFields.fireCauseSpecificDetailID] = null;
      updatedProp[originFields.isCauseProhibited] = null;
    }

    if (fieldName === originFields.fireCauseSpecificId) {
      updatedProp[originFields.fireCauseAgeCategoryID] = null;
      updatedProp[originFields.fireCauseActivityGroupID] = null;
      updatedProp[originFields.fireCauseSpecificDetailID] = null;
      updatedProp[originFields.isCauseProhibited] = null;
    }

    if (this.state.editableIncident && this.state.editableIncident.attributes) {
      const updatedAttributes = {
        attributes: Object.assign({}, this.state.editableIncident.attributes, updatedProp)
      };

      const updatedIncident = Object.assign({}, this.state.editableIncident, updatedAttributes);
      const originValidation = getValidationInfo(enums.validationType.origin, updatedIncident.attributes, this.props.appConfig.fieldInfos);

      this.setState({
        editableIncident: updatedIncident,
        originValidation: originValidation,
        isOriginValid: originValidation.isValid,
        isSaveActive: true
      });

      if (fieldName === "_pointGeometryLatitude") {
        this.setState({ manualLat: newVal });
      }

      if (fieldName === "_pointGeometryLongitude") {
        this.setState({ manualLong: newVal });
      }
    }
  }

  resetAcreageRecalc = () =>
  {
    this.setState({perimeterWasRecalced: false });
  }

  perimeterPropUpdated = (fieldName, newVal) => {
    let updatedProp = {};
    updatedProp[fieldName] = newVal;

    if (this.state.editablePerimeter.attributes) {
      const updatedAttributes = {
        attributes: Object.assign({}, this.state.editablePerimeter.attributes, updatedProp)
      };
      const updatedPerimeter = Object.assign({}, this.state.editablePerimeter, updatedAttributes);

      this.setState({
        editablePerimeter: updatedPerimeter,
        isPerimeterValid: getValidationInfo(this.state.perimeterValidationType, updatedPerimeter.attributes, this.props.appConfig.perimeterFieldInfos).isValid,
        isSaveActive: true
      });
    }

  }

  getDetailsIncidentPanels = (configFields, perimeterConfig) => {
    const shouldDisableForFA = this.props.incident.attributes && this.props.incident.attributes[originFields.incidentTypeCategory] === "FA";
    let requiredFields = getRequiredFields((this.state.mode === "edit" ? this.state.editableIncident : this.props.incident));

    let panelIncident = this.state.mode === "edit" ? this.state.editableIncident : this.props.incident;

    if (panelIncident && !panelIncident.attributes) {
      panelIncident.attributes = this.props.incident.attributes
    }

    let panelPerimeter = this.state.mode === "edit" ? this.state.editablePerimeter : (this.props.incident.perimeter && this.props.incident.perimeter.Feature && this.props.incident.perimeter.Feature.attributes) ? this.props.incident.perimeter.Feature : null;
    const overrideDomainFields = (this.state.mode === "edit" && (this.props.incident.perimeter && this.props.incident.perimeter.Feature && this.props.incident.perimeter.Feature.attributes && this.props.incident.perimeter.Feature.PerimeterSource === "Fire History") ?
      ["FeatureStatus", "DeleteThis", "FeatureAccess"] : []);

    let originPanels = configFields.map(configField => {

      switch (configField.identifier) {
        case "causePanel":
          return (
            <FireCausePanel
              key={configField.title}
              attributes={(panelIncident) ? panelIncident.attributes : null}
              mode={this.state.mode}
              onPropUpdated={(fieldName, newVal) => {
                this.propUpdated(fieldName, newVal)
              }}
              fieldInfos={this.props.appConfig.fieldInfos}
              title={configField.title}
              primaryFields={configField.primary}
              fields={configField.fields}
              secondaryFields={configField.secondary}
              requiredFields={requiredFields}
              staticFields={originFields.staticFields}
              unitValidatorFields={originFields.unitValidatorFields}
              dependentFields={originFields.dependentFields}
              validationType={enums.validationType.origin}
              validationInfo={this.state.originValidation}
              editablePerimeter={this.state.editablePerimeter}
              panelCollapseState={this.state.collapseCompletePanels}
              expandAllPanels={this.state.expandAllPanels}
              resetPanelCollapseFlag={this.resetPanelCollapseFlag.bind(this)}
            />
          );
        case "mergeInfoPanel":
          return (this.props.incident.mergedIncidents && this.props.incident.mergedIncidents.length > 0) ?
          (
            <MergeInfoPanel
              key={configField.title}
              attributes={(panelIncident) ? panelIncident.attributes : null}
              mode={this.state.mode}
              onPropUpdated={(fieldName, newVal) => {
                this.propUpdated(fieldName, newVal)
              }}
              fieldInfos={this.props.appConfig.fieldInfos}
              title={configField.title}
              mergedIncidents={this.props.incident.mergedIncidents}
              primaryFields={configField.primary}
              fields={configField.fields}
              secondaryFields={configField.secondary}
              requiredFields={requiredFields}
              staticFields={originFields.staticFields}
              unitValidatorFields={originFields.unitValidatorFields}
              dependentFields={originFields.dependentFields}
              validationType={enums.validationType.origin}
              validationInfo={this.state.originValidation}
              editablePerimeter={this.state.editablePerimeter}
              panelCollapseState={this.state.collapseCompletePanels}
              expandAllPanels={this.state.expandAllPanels}
              resetPanelCollapseFlag={this.resetPanelCollapseFlag.bind(this)}
            />
          ) 
          : 
          <div/>;

        case "multiAgencyResponsePanel":
          return (
            <MultiAgencyResponsePanel
              key={configField.title}
              attributes={(panelIncident) ? panelIncident.attributes : null}
              initialResources={this.props.incident.initialResources}
              mode={this.state.mode}
              onPropUpdated={(fieldName, newVal) => {
                this.propUpdated(fieldName, newVal)
              }}
              fieldInfos={this.props.appConfig.fieldInfos}
              title={configField.title}
              primaryFields={configField.primary}
              fields={configField.fields}
              addInitialResponseAgency={(addAgency) => {
                this.addInitialResponseAgency(addAgency)
              }}
              removeInitialResponseAgency={(removeAgency) => {
                this.removeInitialResponseAgency(removeAgency)
              }}
              secondaryFields={configField.secondary}
              requiredFields={requiredFields}
              staticFields={originFields.staticFields}
              unitValidatorFields={originFields.unitValidatorFields}
              dependentFields={originFields.dependentFields}
              validationType={enums.validationType.origin}
              validationInfo={this.state.originValidation}
              editablePerimeter={this.state.editablePerimeter}
              panelCollapseState={this.state.collapseCompletePanels}
              expandAllPanels={this.state.expandAllPanels}
              resetPanelCollapseFlag={this.resetPanelCollapseFlag.bind(this)}
            />
          );
        default:
          return (
            <DetailsIncidentPanel
              key={configField.title}
              shouldDisableForFA={shouldDisableForFA}
              onResetAcreageRecalc={this.resetAcreageRecalc}
              perimeterWasRecalced={this.state.perimeterWasRecalced}
              attributes={(panelIncident) ? panelIncident.attributes : null}
              perimeter={this.props.perimeter}
              adsStatus={this.props.selectedIncident.adsStatus}
              mode={this.state.mode}
              onPropUpdated={(fieldName, newVal) => {
                this.propUpdated(fieldName, newVal)
              }}
              onAgencyValidated={(fieldName, agencyVal) => {
                this.agencyPropUpdated(fieldName, agencyVal)
              }}
              onDerivedPropUpdated={(fieldName, newVal) => {
                this.propUpdated(fieldName, newVal)
              }}
              onDeriveSetUpdated={(fields, values) => {
                this.setUpdated(fields, values)
              }}
              fieldInfos={this.props.appConfig.fieldInfos}
              title={configField.title}
              primaryFields={configField.primary}
              fields={configField.fields}
              knownUnitIds={this.props.incident.knownUnitIds}
              clientDerivedPolygonAcres={this.state.clientDerivedPolygonAcres}
              secondaryFields={configField.secondary}
              requiredFields={requiredFields}
              staticFields={originFields.staticFields}
              unitValidatorFields={originFields.unitValidatorFields}
              dependentFields={originFields.dependentFields}
              validationType={enums.validationType.origin}
              validationInfo={this.state.originValidation}
              editablePerimeter={this.state.editablePerimeter}
              panelCollapseState={this.state.collapseCompletePanels}
              expandAllPanels={this.state.expandAllPanels}
              resetPanelCollapseFlag={this.resetPanelCollapseFlag.bind(this)}
            />
          )
      }

    });

    //let perimeterPanel = (this.props.incident.perimeter && this.props.incident.perimeter.Feature && this.props.incident.perimeter.Feature.attributes) ? (
    let perimeterPanel = (
      <DetailsIncidentPanel
        key={perimeterConfig.title}
        shouldDisableForFA={shouldDisableForFA}
        attributes={(panelPerimeter) ? panelPerimeter.attributes : null}
        mode={this.state.mode}
        onPropUpdated={debounce((fieldName, newVal) => {
          this.perimeterPropUpdated(fieldName, newVal)
        }, 1)}
        fieldInfos={(this.props.incident !== null && this.props.incident.perimeter !== null) ? this.props.incident.perimeter.Fields : null}
        perimeterFields={(this.props.incident !== null && this.props.incident.perimeter !== null) ? this.props.incident.perimeter.Fields : null}
        title={perimeterConfig.title}
        fields={perimeterConfig.fields}
        fireOccurenceRecordID={this.props.incident.attributes[originFields.fireOccurenceRecordID]}
        onResetAcreageRecalc={this.resetAcreageRecalc}
        perimeterWasRecalced={this.state.perimeterWasRecalced}
        overrideDomainFields={overrideDomainFields}
        //perimeterAcreage={this.props.incident.perimeterAcreage}
        perimeter={this.props.incident.perimeter}
        unitValidatorFields={[]}
        primaryFields={perimeterConfig.primary}
        secondaryFields={perimeterConfig.secondary}
        validationType={this.state.perimeterValidationType}
        validationInfo={this.state.perimeterValidation}
        panelCollapseState={this.state.collapseCompletePanels}
        expandAllPanels={this.state.expandAllPanels}
        editWasCancelled={this.state.editWasCancelled}
        acresByOwnership={(this.state.mode === "edit") ? this.state.editableAcres : this.props.incident.perimeterAcreage}
        onAcreagePropUpdated={(num, index) => {
          this.onAcreagePropUpdated(num, index)
        }}
        onBeneficialAcreagePropUpdated={(num, index) => {
          this.onBeneficialAcreagePropUpdated(num, index)
        }}
        onAcreagePropRemoved={(index) => {
          this.onAcreagePropRemoved(index)
        }}
        onAcreageRecalculate={() => {
          this.onAcreageRecalculate()
        }}
        onAddNewAcreageRow={() => {
          this.onAddNewAcreageRow()
        }}
        onAcreageLandownerCategoryUpdated={(index, value) => {
          this.onAcreageLandownerCategoryUpdated(index, value)
        }}
        isRecalculatingAcres={this.state.isRecalculatingAcres}
        resetPanelCollapseFlag={this.resetPanelCollapseFlag.bind(this)}
        isPerimeter={true}
      />
    );

    var withPerimeterPanels = originPanels.map(a => ({ ...a }));
    withPerimeterPanels.splice(4, 0, perimeterPanel);

    return withPerimeterPanels;
  }

  certifyIncident = () => {
    this.setState({
      showCertifyAgreement: true
    });
  }

  onCertifyIncidentCancel = () => {
    this.setState({
      showCertifyAgreement: false
    });
  }

  onCertifyIncidentAgreed = () => {
    this.setState({
      showCertifyAgreement: false
    });

    let certifiedIncident = { attributes: Object.assign({}, this.props.incident.attributes) };

    certifiedIncident.attributes[originFields.certifiedField] = originFields.certifiedCodedValue;
    certifiedIncident.attributes[originFields.finalFireReportApprovedBy] = window.api.getUsername();
    certifiedIncident.attributes[originFields.finalFireReportApprovedDate] = new Date().getTime();

    const preCertificationPerimeter = this.props.perimeter;

    window.api.saveOccurenceRecord(certifiedIncident)
      .then(
        result => {
          if (result && !result.error) {
            refreshOriginLayer();

            this.handlePerimeterCertification(preCertificationPerimeter);

            this.props.setIncident(result);

            this.setState({
              isCertified: isIncidentCertified(result)
            });
          }
        },
        error => {
          console.log('edit error', error);
          this.showError((
            <p>There was a problem saving your changes...</p>
          ));
        }
      );
  }

  handlePerimeterCertification = (perimeterToCertify) => 
    {
    const perimeterIsTriangle = isPerimeterTriangleOrMissing(perimeterToCertify);

    if (perimeterToCertify && perimeterToCertify.attributes) 
    {
      if (perimeterIsTriangle) 
      {
        let perimeterToUpdate = Object.assign({}, perimeterToCertify);

        perimeterToUpdate.attributes[perimeterFields.isVisible] = 'No';
        perimeterToUpdate.attributes[perimeterFields.deleteThis] = 'No';

        const perimeterSource = this.props.incident.perimeter.Feature.PerimeterSource;

        //No certifiable perimeter, editing existing one to not visible.
        window.api.updatePerimeter(perimeterToUpdate, this.props.incident, false, perimeterSource).then(
          result => {
            this.props.setPerimeter(null);
          });
      }
      else 
      {
          //Certify perimeter
          window.api.certifyPerimeter(perimeterToCertify, this.props.incident.attributes[originFields.forId]).then(result => {
            this.props.setPerimeter(result);
            this.props.refetchIncidentByForID(this.props.incident.attributes[originFields.forId]);
          },
            error => {
              console.log('edit perimeter error', error);
              this.showError((
                <p>There was a problem saving your perimeter changes...</p>
              ));
            });
      }
    }
  }


  requestFireCode = () => {

    let incident = { attributes: Object.assign({}, this.props.incident.attributes) };
    if ((this.props.incident.attributes[originFields.incidentJurisdictionalAgency] === "FS" || this.props.incident.attributes[originFields.incidentJurisdictionalAgency] === "USFS") && !this.state.requestFireCodeWarnIssued) {
      this.setState({
        requestFireCodeWarnIssued: true,
        showUSFSFireCodeDialog: true
      });
      return;
    }

    incident.attributes[originFields.isFireCodeRequested] = originFields.isFireCodeRequested_RequestedCode;
    this.setState({
      fireCodeRequested: true
    });
    window.api.requestFireCode([incident])
      .then(
        results => {
          if (results && results[0]) {
            if (results[0].success) {
              const updatedIncident = {
                attributes: Object.assign({}, results[0].attributes,
                  {
                    "_pointGeometryLatitude": results[0].geometry.y,
                    "_pointGeometryLongitude": results[0].geometry.x
                  }
                ),
                geometry: results[0].geometry
              }
              this.props.setIncident(updatedIncident);
              this.setState({
                isCertified: isIncidentCertified(updatedIncident),
                fireCodeRequested: true,
                requestFireCodeWarnIssued: false,
                showUSFSFireCodeDialog: false
              });

              refreshOriginLayer();
            }
            else {
              console.warn('update failed', results[0]);
              this.showError((
                <Fragment>
                  <p>There was a problem saving your changes...</p>
                  <p>{results[0].error.description}</p>
                </Fragment>
              ));
            }
          }
        },
        error => {
          console.log('edit error', error);
          this.showError((
            <p>There was a problem saving your changes...</p>
          ));
        }
      );
  }

  decertifyIncident = () => {

    //Handle perimeter decertification
    if (this.props.incident.perimeter && this.props.incident.perimeter.Feature) {
      window.api.decertifyPerimeter(this.props.incident.perimeter.Feature, this.props.incident.attributes[originFields.forId]).then(result => {
        this.props.setPerimeter(result);
      });
    }

    let decertifiedIncident = { attributes: Object.assign({}, this.props.incident.attributes) };
    decertifiedIncident.attributes[originFields.certifiedField] = originFields.decertifiedCodedValue;
    decertifiedIncident.attributes[originFields.finalFireReportApprovedBy] = null;
    decertifiedIncident.attributes[originFields.finalFireReportApprovedDate] = null;

    window.api.saveOccurenceRecord(decertifiedIncident).then(
      result => {
        if (result && !result.error) {

          this.props.setIncident(result);

          this.setState({
            isCertified: isIncidentCertified(result)
          });

          refreshOriginLayer();
        }
        else {
          console.warn('update failed', result);
          this.showError((
            <Fragment>
              <p>There was a problem saving your changes...</p>
              <p>{result.error.description}</p>
              <p>{result.error.description}</p>
            </Fragment>
          ));
        }
      },
      error => {
        console.log('edit error', error);
        this.showError((
          <p>There was a problem saving your changes...</p>
        ));
      }
    );
  }

  handleSuccessSnackRequestClose = () => {
    this.setState({
      updateStatus: "",
    });
  };

  reconcileEditableAcreages = (derivedResult) => 
  {  
    if (this.state.editableAcres) 
    { 
     
      let updatedProp = Object.assign({}, this.state.editableAcres);
      if (updatedProp.AcreageRecords === null || updatedProp.AcreageRecords === undefined) 
      {
        updatedProp.AcreageRecords = [];
      } 

      let catIds = [];
      for (var i = 0; i < derivedResult.length; i++) 
      {
        const catID = derivedResult[i].Category.LandownerCategoryID;
        const derivedAcres = parseFloat(derivedResult[i].Acres);
        catIds.push(catID);
        let existingRecord = updatedProp.AcreageRecords.find(x => x.LandownerCategoryID === catID);
        if (existingRecord) 
        {
          existingRecord.CalculatedAcreage = derivedAcres;
          existingRecord.IsUserOverriden = false;
          existingRecord.CanEditLandowner = false;
          existingRecord.UserProvidedAcreage = null;
        } 
        else 
        {        
          updatedProp.AcreageRecords.push({
            LandownerCategoryID: catID, 
            UserProvidedAcreage: null,
            CanEditLandowner: false,
            IsUserOverriden: false,
            AcreageRecordID: -1,
            CalculatedAcreage: derivedAcres,
            PerimeterID: updatedProp.PerimeterID
          });
        }
      }

      updatedProp.AcreageRecords = updatedProp.AcreageRecords.filter(i => catIds.includes(i.LandownerCategoryID));
      
      this.setState({
        editableAcres: updatedProp
      });
    } 
    else 
    { 
        let calcedTotal = 0;
        let perimeter = {
          CalculatedAcreageTotal: -1,
          FireOccurenceRecordID: this.props.incident.attributes[originFields.fireOccurenceRecordID],
          AcreageRecords: []
        };

        for (var j = 0; j < derivedResult.length; j++) {
          
          calcedTotal += parseFloat(derivedResult[i].Acres);

          perimeter.AcreageRecords.push({
            LandownerCategoryID: derivedResult[j].Category.LandownerCategoryID, 
            UserProvidedAcreage: null,
            CanEditLandowner: false,
            IsUserOverriden: false,
            AcreageRecordID: -1,
            CalculatedAcreage: parseFloat(derivedResult[i].Acres)
          });
        };
        
        perimeter.CalculatedAcreageTotal = calcedTotal;
        this.setState({
          editableAcres: perimeter
        });
    }
  }

  generateNewTriangle = (size) => {
    loadModules(['esri/geometry/support/geodesicUtils', 'esri/geometry/projection', 'esri/geometry/Point', 'esri/geometry/Polygon', 'esri/geometry/SpatialReference'])
      .then(([geodesicUtils, projection, Point, Polygon, SpatialReference]) => {

        const metersPerFoot = 0.3048;
        const sideLengthInFeet = getTriangleSideLengthForAcreage((size) ? size : this.state.editableIncident.attributes.IncidentSize);
        const distanceToVertexInFeet = distanceToVertex(sideLengthInFeet);
        const distanceToVertexInMeters = (distanceToVertexInFeet * metersPerFoot);

        const northPoint = geodesicUtils.pointFromDistance(new Point({ x: this.state.editableIncident.attributes.x, y: this.state.editableIncident.attributes.y }), distanceToVertexInMeters, 0);
        const sePoint = geodesicUtils.pointFromDistance(new Point({ x: this.state.editableIncident.attributes.x, y: this.state.editableIncident.attributes.y }), distanceToVertexInMeters, 120);
        const swPoint = geodesicUtils.pointFromDistance(new Point({ x: this.state.editableIncident.attributes.x, y: this.state.editableIncident.attributes.y }), distanceToVertexInMeters, 240);

        var newTriangle = new Polygon(new SpatialReference(4269));
        newTriangle.rings = [[[northPoint.x, northPoint.y], [sePoint.x, sePoint.y], [swPoint.x, swPoint.y], [northPoint.x, northPoint.y]]];

        projection.load().then(() => {
          const webMercatorTriangle = projection.project(newTriangle, new SpatialReference(102100));

          clearPerimeterGraphics();
          setModifiedPerimeter({
            graphics: [
              {
                geometry: webMercatorTriangle
              }
            ]
          })
            
          this.handleConfirmPerimeterEdit({geometry: webMercatorTriangle});
        });     
      });
  }

  handleConfirmOriginEdit = (args) => {
    loadModules(['esri/geometry/support/webMercatorUtils'])
      .then(([webMercatorUtils]) => {

        let geomWGS84 = webMercatorUtils.webMercatorToGeographic(args.geometry);
        const latitude = geomWGS84.y;
        const longitude = geomWGS84.x;

        let updatedProp = {};

        updatedProp["x"] = longitude;
        updatedProp["y"] = latitude;

        if (this.state.editableIncident && this.state.editableIncident.attributes) 
        {
          const updatedAttributes = { attributes: Object.assign({}, this.state.editableIncident.attributes, updatedProp) };
          const updatedGeomIncident = Object.assign({}, this.state.editableIncident, updatedAttributes);

          this.setState({
            editableIncident: updatedGeomIncident
          });
          
          if (this.state.editablePerimeter && this.state.editablePerimeter.geometry && isPerimeterTriangle(this.state.editablePerimeter)) 
            {
            this.setState({
              showTriangleRegenerationDialog: true
            });
          }
        }
      });
  }

  handleCancelOriginEdit = (args) => {
    const editableIncident = Object.assign({}, this.state.editableIncident, { geometry: null });
    this.setState({ editableIncident });
  }

  handleOnSpliceComplete = (forId) => {
    this.props.refetchIncidentByForID(forId);
  }

  handleOnPerimeterUploaded = (args) => {
    loadModules(['esri/geometry/support/webMercatorUtils'])
      .then(([webMercatorUtils]) => {

        const editablePerimeter = Object.assign({}, this.state.editablePerimeter, { geometry: args.geometry });
        //TODO IMH: Perimeter uploaded

        const projectedGeometry = webMercatorUtils.webMercatorToGeographic(args.geometry);

        window.api.deriveAcresByJurisdiction(projectedGeometry).then(derivedJurisAcresResult => {
          this.reconcileEditableAcreages(derivedJurisAcresResult);
          //Reconcile perimeter acreages with newly derived acres
          this.setState({
            clientDerivedPolygonAcres: derivedJurisAcresResult,
            perimeterWasAdded: true,
            perimeterWasRecalced: true
          });
        });
        this.setState({ editablePerimeter });
      });
  }

  handleConfirmPerimeterEdit = (args) => {
    loadModules(['esri/geometry/support/webMercatorUtils'])
      .then(([webMercatorUtils]) => {

        if (args.geometry === null || args.geometry === undefined) 
        {
          console.log("NULL perimeter geometry");
        }

        let editablePerimeter = Object.assign({}, this.state.editablePerimeter, { geometry: args.geometry });

        if (editablePerimeter.attributes && editablePerimeter.attributes.MapMethod && editablePerimeter.attributes.MapMethod.toUpperCase() === "AUTO-GENERATED") {
          editablePerimeter.attributes.MapMethod = "Hand Sketch";
        }

        if (editablePerimeter.attributes && editablePerimeter.attributes.Comments && editablePerimeter.attributes.Comments.toUpperCase() === "AUTO-GENERATED BY EGP-IRWIN") {
          editablePerimeter.attributes.Comments = "Edited in InFORM Inspector";
        }

        const projectedGeometry = webMercatorUtils.webMercatorToGeographic(args.geometry);

        window.api.deriveCalculatedAcres(args).then(response =>
        {
            this.propUpdated(originFields.calculatedAcres, response);
        });

        window.api.deriveAcresByJurisdiction(projectedGeometry).then(derivedJurisAcresResult => {
          
          this.reconcileEditableAcreages(derivedJurisAcresResult);

          this.setState({
            clientDerivedPolygonAcres: derivedJurisAcresResult,
            perimeterWasAdded: true,
            perimeterWasRecalced: true,
            editableAcresDirty: true
          });
        });
        this.setState({ editablePerimeter });
      });
  }

  handleCancelPerimeterEdit = (args) => {
    const editablePerimeter = Object.assign({}, this.props.selectedIncident.perimeter);
    this.setState({ editablePerimeter: editablePerimeter });

    this.props.setPerimeter(this.props.selectedIncident.perimeter);

    setModifiedPerimeter({
      graphics: [
        {
          geometry: this.props.selectedIncident.perimeter.geometry
        }
      ]
    })

    setPerimeterSymbology({ symbol: symbols.disabledPerimeterSymbol });

  }

  incidentHasAcreageLineDiscrepancy(records, size) 
  {
    if (size < 10) {
      return false;
    }

    const acreageTotal = records.reduce((pv, cv) => pv + ((cv.UserProvidedAcreage !== null) ? parseFloat(cv.UserProvidedAcreage) : parseFloat(cv.CalculatedAcreage)), 0);
    var percDiff =  100 * Math.abs( (acreageTotal - size) / ( (acreageTotal+size)/2 ) );  
    return percDiff > 10;
  }


  showError(message) {
    this.setState({
      errorMessage: message,
      updateStatus: ""
    });
  }

  activateSave = () => {
    this.setState({
      isSaveActive: true
    });
  }
  deactivateSave = () => {
    this.setState({
      isSaveActive: false
    });
  }

  render() {

    const isCertified = (this.props.incident && this.props.incident.attributes && this.props.incident.attributes[originFields.certifiedField] !== null && this.props.incident.attributes[originFields.certifiedField].toUpperCase() === originFields.certifiedCodedValue.toUpperCase());
    const hasAcreageRows = (this.props.incident.perimeterAcreage && this.props.incident.perimeterAcreage.AcreageRecords && this.props.incident.perimeterAcreage.AcreageRecords.length > 0);
    const isFalseAlarm = (this.props.incident && this.props.incident.attributes && this.props.incident.attributes[originFields.incidentTypeCategory] === "FA");
    const configFields = originFields.incidentDetails;
    const perimeterConfigFields = perimeterFields.perimeterDetails;
    const hasAcreageLineDiscrepancy = (this.props.incident && this.props.incident.perimeterAcreage.AcreageRecords) ? this.incidentHasAcreageLineDiscrepancy(this.props.incident.perimeterAcreage.AcreageRecords, this.props.incident.attributes[originFields.incidentSize]) : false;
    const disallowfederalTriangle = this.state.isFederal && this.state.isPerimeterTriangle && (this.state.incidentAcres >= 10);

    let quarantineAlert;
    let incidentStatusAlert;
    let fireCodeAlert;
    let isQuarantined = false;
    var certifyText = "This incident is complete and ready to be certified.";
    var shortCertifyText = "Ready To Be Certified";
    const certifyDisabled = (this.props.auth.isReadOnly || disallowfederalTriangle || isQuarantined || (!hasAcreageRows && !isFalseAlarm) || hasAcreageLineDiscrepancy);

    if (this.props.incident.attributes[originFields.isQuarantined]) {
      isQuarantined = true;
      quarantineAlert = (
        <AlertPanel
          severity={2}
          disabled={this.props.auth.isReadOnly}>
          <p>Note: This incident is marked as being in quarantine in IRWIN.</p>
        </AlertPanel>
      )
    }

    if (isCertified) 
    {
      incidentStatusAlert = (
        <AlertPanel
          severity={3}
          alertHasAction={false}><p>This incident is Certified and must be decertified before editing.</p></AlertPanel>
      )
    }

    else if (this.state.isComplete && (!isCertified)) 
    {
      var originWarning = "";

      if (disallowfederalTriangle) 
      {
        certifyText = "A valid perimeter is required for Federal fires > 10 acres";
        shortCertifyText = "Valid perimeter required";
      }

      if (hasAcreageLineDiscrepancy) 
      {
        certifyText = "Large discrepancy between incident size and landowner acres";
        shortCertifyText = "Incident size discrepancy";
      }
      if (!hasAcreageRows && !isFalseAlarm) 
      {
        certifyText = "Landowner acres needs to be provided before incident can be certified";
        shortCertifyText = "Missing Landowner acres";
      }

      if (!this.state.originWithinPerimeter) 
      {
        originWarning = <p><b>Warning:</b> Origin is outside perimeter</p>;
      }

      incidentStatusAlert = (
        <AlertPanel
          severity={5}
          alertHasAction={this.props.auth.isCertifier && (this.state.mode === "read")}
          actionLabel="Certify Incident"
          disabled={certifyDisabled}
          onActionClicked={this.certifyIncident.bind(this)} >
          <p>{certifyText}</p>
          {originWarning}
        </AlertPanel>
      )
    }

    let editPerimeterToolbar;
    if (this.state.mode === "edit") {
      const originalPerimeterGeometry = (this.props.selectedIncident.perimeter) ? this.props.selectedIncident.perimeter.geometry : null;
      editPerimeterToolbar = (
        <EditGeometryToolbar
          incident={this.props.incident}
          disabled={this.state.is209}
          ref={this.geometryToolbarChild}
          manualLat={this.state.manualLat}
          manualLong={this.state.manualLong}
          perimeter={(this.state.editablePerimeter && this.state.editablePerimeter.geometry) ? this.state.editablePerimeter : this.props.selectedIncident.perimeter}
          isMultipartPerimeter={this.state.isMultipartPerimeter}
          onConfirmOriginEdit={this.handleConfirmOriginEdit.bind(this)}
          onCancelOriginEdit={this.handleCancelOriginEdit.bind(this)}
          onConfirmPerimeterEdit={this.handleConfirmPerimeterEdit.bind(this)}
          onCancelPerimeterEdit={this.handleCancelPerimeterEdit.bind(this)}
          onPerimeterUploaded={this.handleOnPerimeterUploaded.bind(this)}
          onToolbarEditActive={this.deactivateSave}
          onToolbarEditInactive={this.activateSave}
          originWithinPerimeter={this.state.originWithinPerimeter}
          originalPerimeterGeometry={originalPerimeterGeometry}
        />
      )
    }

    const incident = (this.state.mode === "edit") ? this.state.editableIncident : this.props.incident;
    const relationships = this.props.selectedIncident.relationships;
    const incidentName = incident.attributes[originFields.name];

    const canInvalidate = (!this.state.isCertified);
    const canMerge = (!this.state.isCertified);

    return (

      <div className="incident-details">
        <IncidentDetailsHeader
          onEdit={this.editClicked.bind(this)}
          onClose={this.closeDetailsClicked.bind(this)}
          onSaveChanges={this.saveChangesClicked.bind(this)}
          onCancelEdit={this.cancelEditClicked.bind(this)}
          mode={this.state.mode}
          label={incidentName}
          incident={incident}
          originValidation={this.state.originValidation}
          incidentId={incident.attributes[originFields.irwinId]}
          isValid={this.state.isOriginValid}
          isReadOnlyUser={this.props.auth.isReadOnly}
          isCertified={this.state.isCertified}
          missingFieldsCount={this.state.missingFieldsCount}
          canInvalidate={canInvalidate}
          canMerge={canMerge}
          is209={this.state.is209}
          hasResourceSummary={this.state.hasResourceSummary}
          isSaveActive={this.state.isSaveActive}
          showError={this.showError.bind(this)}
          onFireReportingADSChange={this.fireReportingStatusUpdated.bind(this)}
          setPanelCollapseFlag={this.setPanelCollapseFlag.bind(this)}
          onSpliceComplete={this.handleOnSpliceComplete.bind(this)}
        />
        <div className="incident-details-content">
          {quarantineAlert}
          {incidentStatusAlert}
          {fireCodeAlert}
          <DetailsDashboardPanel
            incident={incident}
            certifyDisabled={certifyDisabled}
            certifyDisableText={shortCertifyText}
            relationships={relationships}
            irwinRelationships={this.props.incident.irwinRelationshipRecords}
            adsStatus={this.props.selectedIncident.adsStatus}
            mode={this.state.mode}
            isValid={this.state.isOriginValid && this.state.isPerimeterValid}
            isComplete={this.state.isComplete}
            isCertified={this.state.isCertified}
            isFederal={this.state.isFederal}
            canRequestFireCode={false}
            isPerimeterTriangle={this.state.isPerimeterTriangle}
            incidentAcres={this.state.incidentAcres}
            isReadOnlyUser={this.props.auth.isReadOnly}
            missingFieldsCount={this.state.missingFieldsCount}
            originWithinPerimeter={this.state.originWithinPerimeter}
            fireCodeRequested={this.state.fireCodeRequested}
            onPropUpdated={debounce((fieldName, newVal) => {
              this.propUpdated(fieldName, newVal)
            }, 1)}
            onCertifyIncident={this.certifyIncident.bind(this)}
            onDecertifyIncident={this.decertifyIncident.bind(this)}
            onRequestFireCode={this.requestFireCode.bind(this)}
          />
          {this.getDetailsIncidentPanels(configFields, perimeterConfigFields)}
        </div>
        {editPerimeterToolbar}
        <Snackbar
          open={Boolean(this.state.updateStatus)}
          message={this.state.updateStatus}
          autoHideDuration={5000}
          onClose={this.handleSuccessSnackRequestClose}
        />
        <Dialog
          title="Missing Related Incidents"
          actions={[
            <Button
              keyboardFocused={true}
              onClick={this.handleRelationshipsDialogClose}>OK</Button>
          ]}
          modal={true}
          open={this.state.warnForMissingRelationships}
          contentStyle={styles.errorDialogContent}
          titleStyle={styles.errorDialogTitle}>
          This incident is marked as Quarantined, but related Parent/Child Incidents were not found, and conflict resolution cannot proceed. <p>
            This may indicate that this Incident should be marked as invalid.</p>
        </Dialog>
        <Dialog
          title="Re-center autogenerated perimeter?"
          actions={[
            <Button
              keyboardFocused={true}
              onClick={this.handleTriangleRegenerationYes}>Yes</Button>,
              <Button
              keyboardFocused={true}
              onClick={this.handleTriangleRegenerationNo}>No</Button> 
          ]}
          modal={true}
          open={this.state.showTriangleRegenerationDialog}
          contentStyle={styles.errorDialogContent}
          titleStyle={styles.errorDialogTitle}>
          You have updated the point of origin, do you want to re-center the auto-generated triangle perimeter? 
        </Dialog>
        <Dialog
          title="Error Saving Changes"
          actions={[
            <Button
              keyboardFocused={true}
              onClick={this.handleErrorDialogClose}>Close</Button>
          ]}
          modal={false}
          open={this.state.errorMessage !== ""}
          contentStyle={styles.errorDialogContent}
          titleStyle={styles.errorDialogTitle}
          onRequestClose={this.handleErrorDialogClose} >
          {this.state.errorMessage}
        </Dialog>
        <Dialog
          title="Confirm USFS Firecode Request"
          actions={[
            <Button
              onClick={this.handleFSFireCodeYes}>Yes</Button>,
            <Button
              onClick={this.handleFSFireCodeNo}>No</Button>
          ]}
          modal={true}
          open={this.state.showUSFSFireCodeDialog}
          contentStyle={styles.errorDialogContent}
          titleStyle={styles.errorDialogTitle}>
          This incident has USFS as its Jurisdictional Agency, are you sure you want to request a firecode? <br /> <br />
          Please enter a ABCD misc code if applicable.
        </Dialog>

        <CertifyDialog
          open={this.state.showCertifyAgreement}
          onCertifyIncidentCancel={this.onCertifyIncidentCancel}
          onCertifyIncident={this.onCertifyIncidentAgreed}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  selectedIncident: state.incident,
  auth: state.auth,
  manualLat: state.manualLat,
  manualLong: state.manualLong,
  isPerimeterTriangle: state.isPerimeterTriangle,
  incidentAcres: state.incidentAcres,
  fireCodeRequested: state.fireCodeRequested,
  originWithinPerimeter: state.originWithinPerimeter
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...incidentOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(IncidentDetailsContainer)
